// Modules
import Common from "./modules/common";
import Animate from "./modules/animate";
import Header from "./modules/header";
import Lightbox from "./modules/lightbox";
import OB from "./modules/outdated-browser";
import Youtube from "./modules/youtube";

// Autoload modules
const modules = [Common, Animate, Header, Lightbox, OB, Youtube];

modules.forEach((module) => {
  module.init();
});

// import local dependencies
import Router from "./utils/Router";
import templateHome from "./partials/template-home";
import templatePortfolio from "./partials/template-portfolio";
import singlePortfolio from "./partials/single-portfolio";
import singleCaseStudies from "./partials/single-case-studies";
import singlePost from "./partials/single-post";
import templateContacts from "./partials/template-contacts";
import templateBusiness from "./partials/template-business";
import templateBusinessOpen from "./partials/template-business-open";
import templateDestinationOpen from "./partials/template-destination-open";
import templateServicePackages from "./partials/template-service-packages";
import templateEvents from "./partials/template-event";
import templateIdeas from "./partials/template-idea";
import pageTemplateDefault from "./partials/template-default";

// Populate Router instance with DOM routes
const routes = new Router({
  templateHome,
  templatePortfolio,
  singlePortfolio,
  singleCaseStudies,
  singlePost,
  templateContacts,
  templateContactForm: templateContacts,
  templateBusinessOpen,
  templateBusiness,
  templateDestinationOpen,
  templateServicePackages,
  templateEvents,
  templateIdeas,
  pageTemplateDefault,
});

// Load Events
routes.loadEvents();
